import axios from '@/utils/request';
const prefix = process.env.VUE_APP_API_PREFIX_1;
const baseOriginURL = `${prefix}/menu_access`;

// 记录页面访问
const RecordPageAccess = data => {
  return axios.post(`${baseOriginURL}/RecordPageAccess`, data);
}

export { RecordPageAccess }